isFourteenMonthPlan